<app-http-loader />

<router-outlet />
